import { Avatar, Flex, Tooltip } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const StyledLink = styled(Link)`
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.text.secondary2};
  font-family: ${({ theme }) => theme.fonts.heading};
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  display: block;
`;

export const ReworkContributorCell = ({
  contributor,
}: {
  contributor: string;
}) => (
  <Flex align="flex-start" gap={2} w="full">
    <Avatar size="xs" name={contributor} />
    <Tooltip
      label={contributor}
      hasArrow
      isDisabled={!contributor || contributor.length < 30}
    >
      <StyledLink to={`/contributors/${contributor}`}>{contributor}</StyledLink>
    </Tooltip>
  </Flex>
);
